import React, { Component } from 'react';
import axios from "axios";
import {appConfig} from "./../../tools/AppConfig";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Select from 'react-validation/build/select';
import Button from 'react-validation/build/button';
import Waiting from './../waiting';
import './../../custom.css';
import './../../pages/invoice.css';
import premium_logoImg from './../../../statics/img/premium_logo.gif';
import acceptBlueImg from './../../../statics/img/accept_blue.png';
import validator from 'validator';
const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> This field is required.</div>;
  }
};
const PremiumCard = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length !== 16 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Premium Card number.</div>;
    }
};
const Pin = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length !== 6 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Premium Card number.</div>;
    }
};

class premium extends Component {
      constructor(props) {
        super(props);
        this.state = {
            waiting: false,
            waitingHeight: '221px',
            userData: props.userData,
            deliveryNeed: props.deliveryNeed,
            deliveryData: props.deliveryData,
            cardNumber: '',
            expiryMonth: '',
            expiryYear: '',
            pmk: '',
            reference: '',
            pin: '',
            firstStepDisable: false,
            firstFormSubmitBtn: true,
            secondSetpShow: false,
        };
        this.getFirstName = this.getFirstName.bind(this);
        this.getLastName = this.getLastName.bind(this);
        this.handleCardNumChange = this.handleCardNumChange.bind(this);
        this.handelExpiryMonthChange = this.handelExpiryMonthChange.bind(this);
        this.handelExpiryYearChange = this.handelExpiryYearChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handelPinChange = this.handelPinChange.bind(this);
        this.handleForm2Submit = this.handleForm2Submit.bind(this);
      }
  
    getFirstName(fullName) {
        var namesArr = fullName.split(" ");
        return namesArr[0]
    }
    getLastName(fullName) {
        var namesArr = fullName.split(" ");
        return namesArr[namesArr.length - 1];
    }
  handleCardNumChange(e) {
    this.setState({cardNumber: e.target.value});
  }
  handelExpiryMonthChange(e) {
      this.setState({expiryMonth: e.target.value});
  }
  handelExpiryYearChange(e) {
    this.setState({expiryYear: e.target.value});
  }
  handleSubmit(event) {
    //--- strat waiting
    this.setState({waiting: true});
    //disable payment methods
    this.props.disableAllPaymentMethods();
    //---- send request 
    let url;
    if(this.props.sourcePage ==='invoice'){
        url = appConfig.getServerUrl() + '/invoice2/'+ this.state.userData.token;
    }else if(this.props.sourcePage ==='product'){
        url = appConfig.getServerUrl() + '/product2/'+ this.state.userData.token;
    }
    let paymentDict;
    if(this.props.sourcePage ==='invoice'){
        paymentDict = {
            "source": {
                "identifier": this.state.cardNumber,
                "subtype": "PREMIUM",
                "expiry_month": this.state.expiryMonth,
                "expiry_year": this.state.expiryYear
            }, "shipping_data": {
                'apartment': "",
                'email': this.state.userData.order_email,
                'floor': "",
                'first_name': this.getFirstName(this.state.userData.order_full_name),
                'street': "",
                'building': "",
                'phone_number': this.state.userData.order_phone,
                'postal_code': "",
                'city': "",
                'country': "",
                'last_name': this.getLastName(this.state.userData.order_full_name),
                'state': "",
                'extra_description': ""
            },
            "token": this.state.userData.token,
            "integration_id": this.state.userData.integration_ids.PREMIUM        
        };
        if(this.state.deliveryNeed){
            paymentDict.shipping_data.country = this.state.deliveryData.country;
            paymentDict.shipping_data.state = this.state.deliveryData.state;
            paymentDict.shipping_data.city = this.state.deliveryData.city;
            paymentDict.shipping_data.building = this.state.deliveryData.building;
            paymentDict.shipping_data.street = this.state.deliveryData.street;
            paymentDict.shipping_data.floor = this.state.deliveryData.floor;
            paymentDict.shipping_data.apartment = this.state.deliveryData.apartment;
            paymentDict.shipping_data.postal_code = this.state.deliveryData.postal_code;
            paymentDict.shipping_data.extra_description = this.state.deliveryData.notes;
        }
    }else if(this.props.sourcePage ==='product'){
        paymentDict = {
            "order_data": {
                "delivery_needed": this.state.deliveryNeed,
                "amount_cents": this.state.userData.amount * this.props.quantity * 100,
                "currency": this.state.userData.currency,
                "shipping_data": {
                    "first_name": this.getFirstName(this.state.deliveryData.name),
                    "last_name": this.getLastName(this.state.deliveryData.name),
                    "phone_number": this.state.deliveryData.phone,
                    "email": this.state.deliveryData.email,
                    "street": 'NA',
                    "city": 'NA',
                    "country": 'NA',
                    "postal_code": 'NA',
                    "state": "NA"
                },
                "items": [{
                    "name": this.state.userData.product.product_name,
                    "amount_cents": this.state.userData.amount * 100,
                    "quantity": this.props.quantity,
                }]
            },
            "source": {
                "identifier": this.state.cardNumber,
                "subtype": "PREMIUM",
                "expiry_month": this.state.expiryMonth,
                "expiry_year": this.state.expiryYear
            },
            "token": this.state.userData.token,
            "integration_id": this.state.userData.integrations.PREMIUM
        };
        if(this.state.deliveryNeed){
            paymentDict.order_data.shipping_data.country = this.state.deliveryData.country;
            paymentDict.order_data.shipping_data.state = this.state.deliveryData.state;
            paymentDict.order_data.shipping_data.city = this.state.deliveryData.city;
            paymentDict.order_data.shipping_data.building = this.state.deliveryData.building;
            paymentDict.order_data.shipping_data.street = this.state.deliveryData.street;
            paymentDict.order_data.shipping_data.floor = this.state.deliveryData.floor;
            paymentDict.order_data.shipping_data.apartment = this.state.deliveryData.apartment;
            paymentDict.order_data.shipping_data.postal_code = this.state.deliveryData.postal_code;
            paymentDict.order_data.shipping_data.extra_description = this.state.deliveryData.notes;
        }
    }
    paymentDict = JSON.stringify(paymentDict);
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.post(url, paymentDict, config)
    .then((resp) => {
        if(resp.data.success){
            //set pmk value & reference value and & waiting & show second form % disable first form & remove first form submit button
            this.setState({pmk: resp.data.pmk, reference: resp.data.reference, waiting: false, secondSetpShow: true, firstStepDisable: true, firstFormSubmitBtn: false});
            //enable payment methods
            this.props.enableAllPaymentMethods();
        }else{
            this.props.setReqComplete({head: '', body:'Invalid card number or expire date.'});
        }
    })
    .catch((err) => {
        this.props.setReqComplete({head: 'Transaction declined', body:'Please try again later. If this problem persists, please contact your service provider.'});
    });
    event.preventDefault();
  }
  handelPinChange(e){
    this.setState({pin: e.target.value});
  }
  handleForm2Submit(event){
    //--- strat waiting
    this.setState({waitingHeight: '289px', waiting: true});
    //disable payment methods
    this.props.disableAllPaymentMethods();
    //send request
    let url= 'https://accept.paymobsolutions.com/api/acceptance/prm_checkout';
    let opt_dict = {
        "payment_token": this.state.pmk,
        "reference": this.state.reference,
        "otp": this.state.pin
    };
    let paymentDict = JSON.stringify(opt_dict);
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.post(url, paymentDict, config)
    .then((resp) => {
        if(resp.data.success === true){
            this.props.setReqComplete({head: 'Transaction Successful', body:'Thank you for choosing Paymob Accept. Premium team will get in touch to take it further from here.'});            
        }else{
            //succes = false
            this.props.setReqComplete({head: 'Transaction declined', body:'Please make sure that you entered the correct OTP.'});
        }
    })
    .catch((err) => {
        this.props.setReqComplete({head: 'Something went wrong', body:'Please try again later. If this problem persists, please contact your service provider.'});
    });
    event.preventDefault();
  }
  render() {
    return (
        <div className="panel panel-default credit-card-box">
            <div className="panel-heading">
                <div className="row display-tr" >
                    <h2 className="panel-title payment-title" >Premium Card Details</h2>
                </div>
            </div>
            <div className="panel-body" id="card_content">
                
                {this.state.waiting ? 
                    <Waiting height={this.state.waitingHeight} />
                :  
                    <div>
                        <Form onSubmit={this.handleSubmit}>
                            <div>
                                <div className="row">
                                    <div className="col-xs-11">
                                        <div className="form-group">
                                            <label>CARD NUMBER</label>
                                            <div className="form-group">
                                                <Input type="number" pattern="[0-9]*" className="form-control" name="c_pan_U" placeholder="16 digits"
                                                    value={this.state.cardNumber} 
                                                    onChange={this.handleCardNumChange}
                                                    validations={[required, PremiumCard]} 
                                                    disabled={this.state.firstStepDisable}
                                                />
                                                <span className="input-group-addon">
                                                    <i className="glyphicon glyphicon-credit-card"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xs-5 ">
                                        <div className="form-group">
                                            <label>
                                                EXP. MONTH
                                            </label>
                                            <Select className="form-control" id="cardExMM" name="c_expiry_mm_U" required 
                                                value={this.state.expiryMonth}
                                                onChange={this.handelExpiryMonthChange}
                                                validations={[required]} 
                                                disabled={this.state.firstStepDisable}
                                            >
                                                <option value="" disabled>--</option>
                                                <option value="01">01</option>
                                                <option value="02">02</option>
                                                <option value="03">03</option>
                                                <option value="04">04</option>
                                                <option value="05">05</option>
                                                <option value="06">06</option>
                                                <option value="07">07</option>
                                                <option value="08">08</option>
                                                <option value="09">09</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                            </Select>
                                        </div>
                                    </div>

                                    <div className="col-xs-5 col-sm-offset-1">
                                        <div className="form-group">
                                            <label>
                                                EXPIRY YEAR
                                            </label>
                                            <Select className="form-control" id="cardExYY" name="c_expiry_yy_U"  required
                                                value={this.state.expiryYear}
                                                onChange={this.handelExpiryYearChange}
                                                validations={[required]} 
                                                disabled={this.state.firstStepDisable}
                                            >
                                                <option value="" disabled>--</option>
                                                <option value="23">2023</option>
                                                <option value="24">2024</option>
                                                <option value="25">2025</option>
                                                <option value="26">2026</option>
                                                <option value="27">2027</option>
                                                <option value="28">2028</option>
                                                <option value="29">2029</option>
                                                <option value="30">2030</option>
                                                <option value="31">2031</option>
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                                <div className="row text-left">
                                    <div className="col-md-12">
                                        <h6>* An SMS will be sent to you with a one-time pin to proceed with the payment.</h6>
                                    </div>
                                </div>
                                {this.state.firstFormSubmitBtn?
                                    <div className='text-center'>
                                        <Button className="btn btn-primary active">GET OTP</Button>
                                    </div>
                                :
                                    null
                                }
                            </div>
                        </Form>
                        <Form onSubmit={this.handleForm2Submit}>
                            {this.state.secondSetpShow?
                                <div>
                                    <div className="row">
                                        <div className="col-xs-11">
                                            <div className="form-group">
                                                <label>One Time Pin</label>
                                                <Input type="number" pattern="[0-9]*" className="form-control" name="one time pin" placeholder="123456"
                                                    value={this.state.pin}
                                                    onChange={this.handelPinChange}
                                                    validations={[required, Pin]} 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='text-center'>
                                        <Button className="btn btn-primary active">Confirm</Button>
                                    </div>
                                </div>
                            :
                                null
                            }
                        </Form>
                    </div>
                }
                <div className="row">
                    <div className="col-xs-12">
                        <div className="col-xs-6 col-md-6 col-sm-6 text-center">
                            <span><h5>Sponsored by</h5></span>
                            <span><img style={{width: '50%', height: 'auto', marginLeft: '25%'}} className="img-responsive" alt="premium logo" src={premium_logoImg} /></span>
                        </div>
                        <div className="col-xs-6 text-center">
                            <span><h5>Powered by</h5></span>
                            <span><img style={{width: '70%', height: 'auto', marginLeft: '15%'}} className="img-responsive" alt="accept logo" src={acceptBlueImg} /></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

export default premium;
